import gql from 'graphql-tag'

export const GET_PRODUCT_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $search: String
    $showInShop: Boolean
    $showInMiniCatalog: Boolean
    $currency: String
  ) {
    getProductPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $search
        showInShop: $showInShop
        showInMiniCatalog: $showInMiniCatalog
        currency: $currency
      }
    ) {
      hasMore
      total
      items {
        id
        productInfo {
          alt
          titleEn
          titleRu
          titleKg
        }
        prices {
          price
          overprice
          wholesalePrice
          currencyObj {
            symbol
            title
          }
        }
        coverImage
        showInShop
        status
        quantity
        tag
        discount
        showInMiniCatalog
        category {
          titleEn
          titleKg
          titleRu
        }
        subcategory {
          titleEn
          titleRu
          titleKg
          category {
            titleEn
            titleKg
            titleRu
          }
        }
        brand {
          titleEn
          titleRu
          titleKg
          image
        }
				color {
					id
					titleEn
					titleRu
					titleKg
				}
				size
				volume
      }
    }
  }
`;

export const EXPORT_PRODUCTS_CATALOG_QUERY = gql`
  query {
    exportProductsCatalog {
      fileName
      mimeType
      content
    }
  }
`;

export const GET_PRODUCT_IMAGES_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProductImages (
      id: $id
    ) {
      id
      fullUri
      isMain
    }
  }
`;

export const GET_PRODUCT_WITH_EXTRA_DATA_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProduct (
      data: {
        id: $id
      }
    ) {
      id
      brandId
      categoryId
      subcategoryId
      coverImage
      productInfo {
        alt
        descriptionEn
        descriptionKg
        descriptionRu
        descriptionShortEn
        descriptionShortKg
        descriptionShortRu
        titleEn
        titleKg
        titleRu
        keywordsEn
        keywordsKg
        keywordsRu
      }
      discount
      homeBanner
      prices {
        currency
        price
        overprice
        wholesalePrice
      }
			coinsArray
      quantity
      showInShop
      status
      tag
			volume
			country
			expiration
			colorId
			size
    }
    getAllProductBrands {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllProductCategories {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllCurrencies {
      title
      symbol
      left
    }
    getAllProductSubcategories {
      id
      titleEn
      titleRu
      titleKg
      category {
        titleEn
        titleKg
        titleRu
      }
    }
    getProductIdsByProductInfo(id: $id) {
			id
			color {
				id
				titleEn
				titleRu
				titleKg
			}
			size
			volume
		}
		getCurrentExchangeRateGroup {
			id
			defaultCurrency {
				title
				symbol
				main
			}
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
		getCurrentCoinsRateGroup {
			id
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
		getProductPriceCoinsPolicyAll {
			id
			level {
				title
				level
			}
			discount
		}
  }
`;

export const GET_PRODUCT_EXTRA_DATA_QUERY = gql`
  query {
    getAllProductBrands {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllProductCategories {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllCurrencies {
      title
      symbol
      left
    }
    getAllProductSubcategories {
      id
      titleEn
      titleRu
      titleKg
      category {
        titleEn
        titleKg
        titleRu
      }
    }
		getCurrentExchangeRateGroup {
			id
			defaultCurrency {
				title
				symbol
				main
			}
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
		getCurrentCoinsRateGroup {
			id
			rates {
				id
				currency {
					title
					symbol
					main
				}
				value
			}
		}
		getProductPriceCoinsPolicyAll {
			id
			level {
				title
				level
			}
			discount
		}
  }
`;

export const GET_PRODUCT_INFO_WITH_EXTRA_DATA_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProduct (
      data: {
        id: $id
      }
    ) {
      id
      brandId
      categoryId
      subcategoryId
      productInfo {
        alt
        descriptionEn
        descriptionKg
        descriptionRu
        descriptionShortEn
        descriptionShortKg
        descriptionShortRu
        titleEn
        titleKg
        titleRu
        keywordsEn
        keywordsKg
        keywordsRu
      }
      country
    }
    getAllProductBrands {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllProductCategories {
      id
      titleEn
      titleRu
      titleKg
    }
    getProductIdsByProductInfo(id: $id) {
			id
			color {
				id
				titleEn
				titleRu
				titleKg
			}
			size
			volume
		}
    getAllProductSubcategories {
      id
      titleEn
      titleRu
      titleKg
      category {
        titleEn
        titleKg
        titleRu
      }
    }
  }
`;

export const GET_CONNECT_PRODUCT_QUERY = gql`
  query (
    $id: Int!
  ) {
    getProduct (
      data: {
        id: $id
				linkConnectedProducts: true
      }
    ) {
      id
			coverImage
			color {
				id
				titleEn
				titleRu
				titleKg
			}
			volume
			size
			productInfo {
				alt
				titleEn
				titleRu
				titleKg
			}
      connectIds
			connectedProducts {
				id
				coverImage
				productInfo {
					alt
					titleEn
					titleRu
					titleKg
				}
				color {
					id
					titleEn
					titleRu
					titleKg
				}
				volume
				size
			}
    }
  }
`;

export const GET_PRODUCT_LIGHT_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProduct (
      data: {
        id: $id
      }
    ) {
      id
      coverImage
      productInfo {
        alt
        titleEn
        titleKg
        titleRu
      }
      prices {
        currency
				currencyObj {
					symbol
					title
				}
        price
        overprice
        wholesalePrice
      }
			volume
			colorId
			size
    }
  }
`;
